import { Component } from '@angular/core';
import { NavController,  ViewController, Config,} from 'ionic-angular';

import { UserMyRadiant as User, PermitProvider, Me } from '../../providers';
import { Nav, NavParams, MenuController, Events, } from 'ionic-angular';
import { RepositoryMyRadiant } from '../../providers';


@Component({
  selector: 'about-app',
  templateUrl: 'page.html'
})
export class AboutApp {
  loading : any;
  formPermit = {
    type:'',
    date:'',
    purpose:'',
  };
  parameter = {
    app:this.navParams.get('params'),
  };
  data = {
    listAbout:{
      backButtonText:{
        myradiant:'About',
        activity:'Activity',
        presensi:'About',
      },
      title:{
        myradiant:'My Radiant',
        activity:'Activity',
        presensi:'Presensi',
      }
    },
    activeShow:{
      title:'My Radiant',
    }
    
  };
  
  
  constructor(
    public navCtrl            : NavController,
    public userApi            : User,
    public menuCtrl           : MenuController,
    public nav                : Nav,
    public navParams          : NavParams,
    public repositoryProvider : RepositoryMyRadiant,
    public activityProvider   : Me,
    public viewCtrl           : ViewController,
    public events             : Events,
    public config             : Config,
    ) {
    this.config.set('backButtonText',this.data.listAbout.backButtonText[this.parameter.app]);
    this.data.activeShow.title = this.data.listAbout.title[this.parameter.app];
   
  }

  
}



// WEBPACK FOOTER //
// ./src/pages/about/page.ts